import React, { useContext } from 'react';
import { GrLogout } from 'react-icons/gr';
import { BsSunFill, BsMoonFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../services/Auth/AuthContext';
import { useTheme } from '../../hooks/ThemeContext';

const UserData: React.FC = () => {

	const navigate = useNavigate();
	const auth = useContext(AuthContext);
	const { theme, toggleTheme } = useTheme();

	let username = '';
	let email = '';
	let roles: string[] = [];

	const user = auth.user;
	if (user) {
		username = user.username;
		email = user.email;
		roles = user.roles;
	}

	const handleLogout = () => {
		if (window.confirm("Deseja realmente efetuar o logout do sistema?")) {
			navigate('/logout');
		}
	};

	return (
		<div className="border-t p-2 dark:text-white">

			<div className="grid grid-rows-3 grid-flow-col">

				<div className="text-sm font-semibold max-w-64 truncate">{username}</div>
				<div className="text-sm max-w-64 truncate">{email}</div>
				<div className="text-sm max-w-64 truncate">{roles.join(",")}</div>

				<div className="row-span-3 flex items-center justify-center space-x-2">
					<button
						className="text-slate-500 dark:text-slate-300 p-2 rounded-full transition ease-in duration-200 hover:text-white z-90 hover:bg-slate-500 dark:hover:bg-slate-700 hover:shadow"
						onClick={toggleTheme}
					>
						{theme === 'light' ? <BsMoonFill /> : <BsSunFill />}
					</button>
					<button
						className="text-slate-500 dark:text-slate-300 p-2 rounded-full transition ease-in duration-200 hover:text-white z-90 hover:bg-slate-500 dark:hover:bg-slate-700 hover:shadow"
						onClick={handleLogout}
					>
						<GrLogout />
					</button>
				</div>
			</div>
		</div>
	);
};

export default UserData;